
export const messages = [
// *****  Question  *****
  {
    MessageID: 'KI_Q001',
    MessageText: '質問形式のメッセージ１',
    MessageDefault: 'Button1',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_Q002',
    MessageText: '質問形式のメッセージ',
    MessageDefault: 'Button2',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_Q099',
    MessageText: 'ダミーQuestion。 宜しいですか？',
    MessageDefault: 'Button1',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_Q100',
    MessageText: '{0}します。\nよろしいですか？',
    MessageDefault: 'Button1',
    ParameterDescription: '0：追加/変更',
  },
  {
    MessageID: 'KI_Q101',
    MessageText: '選択したデータを{0}します。\nよろしいですか？',
    MessageDefault: 'Button1',
    ParameterDescription: '0：確定/生成/送信/更新/取消',
  },
  {
    MessageID: 'KI_Q102',
    MessageText: '選択したファイルを取り込みます。\nよろしいですか？',
    MessageDefault: 'Button1',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_Q103',
    MessageText: '{0}。\n{1}よろしいですか？',
    MessageDefault: 'Button1',
    ParameterDescription: '0：主メッセージ、1：閉局して',
  },
  {
    MessageID: 'KI_Q104',
    MessageText: '{0}します。\nよろしいですか？',
    MessageDefault: 'Button2',
    ParameterDescription: '0：削除/取消/訂正',
  },

// *****  Information  *****
  {
    MessageID: 'KI_I001',
    MessageText: '仮パスワードをメールに送信しました。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_I099',
    MessageText: 'ダミーInformation',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_I100',
    MessageText: '指定した{0}は{1}です。',
    ParameterDescription: '',
  },

// *****  Warning  *****
  {
    MessageID: 'KI_W001',
    MessageText: 'パスワードは {0} 文字以上で設定してください。',
    ParameterDescription: '0:文字数',
  },
  {
    MessageID: 'KI_W002',
    MessageText: 'パスワードは大文字、小文字、数字を含めてください。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W003',
    MessageText: 'パラメータ {0} が無効です',
    ParameterDescription: '0:一番最初に見つかった不正なパラメータの項目名',
  },
  {
    MessageID: 'KI_W004',
    MessageText: 'ログインに失敗しました。入力されたログイン情報が 間違っています。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W005',
    MessageText: 'ユーザーが存在しません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W006',
    MessageText: '確認用（新規パスワードと同じものを入力してください）',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W007',
    MessageText: '必須項目',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W008',
    MessageText: '該当データ無',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W009',
    MessageText: '無効な日付',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W010',
    MessageText: '最大文字数',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W011',
    MessageText: '該当データ有',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W012',
    MessageText: '{0}は{1}桁から{2}桁の範囲のみ指定できます。',
    ParameterDescription: '0:項目名 1:桁数(最小) 2:桁数(最大)',
  },
  {
    MessageID: 'KI_W013',
    MessageText: '{0}は{1}のみ指定できます。',
    ParameterDescription: '0:項目名 1:型名',
  },
  {
    MessageID: 'KI_W014',
    MessageText: '過去に使用したパスワードには変更できません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W015',
    MessageText: '一定時間が経過したためセッションが切れました。\nログイン画面に遷移します。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W099',
    MessageText: 'ダミーWarning！！',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W100',
    MessageText: '{0}は必須入力です。',
    ParameterDescription: '0:項目名（単項目）',
  },
  {
    MessageID: 'KI_W101',
    MessageText: '{0}は(開始)≦(終了)となるように入力してください。',
    ParameterDescription: '0:項目名',
  },
  {
    MessageID: 'KI_W102',
    MessageText: '指定した{0}は{1}です。',
    ParameterDescription: '0:項目名、1：未来日/過去日　※警告用',
  },
  {
    MessageID: 'KI_W103',
    MessageText: '指定した{0}は既に存在しています。',
    ParameterDescription: '0:項目名',
  },
  {
    MessageID: 'KI_W104',
    MessageText: '{0}を超える{1}は入力できません。',
    ParameterDescription: '0:項目名又は桁数、1:項目名',
  },
  {
    MessageID: 'KI_W105',
    MessageText: '行を選択してください。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W106',
    MessageText: '該当データが存在しません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W107',
    MessageText: '他の端末で更新されています。\n再度情報を取得してください。',
    ParameterDescription: '※排他エラー時のメッセージ',
  },
  {
    MessageID: 'KI_W108',
    MessageText: '指定した{0}は入力できません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W109',
    MessageText: '指定した{0}は{1}のため入力できません。',
    ParameterDescription: '1：非開局日　※エラー時用',
  },
  {
    MessageID: 'KI_W110',
    MessageText: '{0}を選択している場合は、{1}できません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W111',
    MessageText: '{0}の場合は、{1}できません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W112',
    MessageText: '{0}ため、{1}できません。{2}してください。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W113',
    MessageText: '{0}が入力されていません。',
    ParameterDescription: '0：明細/項目名（一覧）',
  },
  {
    MessageID: 'KI_W114',
    MessageText: '業務が開始されていないため処理できません。',
    ParameterDescription: '※閉局されている場合に使用',
  },
  {
    MessageID: 'KI_W115',
    MessageText: '現在日付が変わったため再ログインが必要です。',
    ParameterDescription: '※ログイン時の現在日付が変わったとき',
  },
  {
    MessageID: 'KI_W116',
    MessageText: '指定したファイルは存在しません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W117',
    MessageText: '{0}がマスタに正しく設定されていません。',
    ParameterDescription: '0:項目名',
  },
  {
    MessageID: 'KI_W118',
    MessageText: '送信処理に失敗した明細が存在します。確認してください。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W119',
    MessageText: '選択したファイルはPDFファイルではありません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W120',
    MessageText: '帳票作成に失敗した明細が存在します。確認してください。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W121',
    MessageText: '入力内容に誤りがあります。確認してください。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W122',
    MessageText: '{0}が最大桁数を超えています。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W123',
    MessageText: '{0}ため、{1}できません。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W124',
    MessageText: '情報が更新されているため、再読込します。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_W125',
    MessageText: '{0}が存在しません。',
    ParameterDescription: '',
  },

// *****  Error  *****
  {
    MessageID: 'KI_E001',
    MessageText: 'システムエラーが発生しました。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_E002',
    MessageText: 'サーバでエラーが発生しました。',
    ParameterDescription: '',
  },
  {
    MessageID: 'KI_E099',
    MessageText: 'ダミーError！！',
    ParameterDescription: '',
  },

];